import React, { useState } from "react";
import FaqItem from "./FaqItem";

const faqs = [
    {
        id: 1,
        question: "Какие способы доставки вы предлагаете?",
        answer:
            "Мы предлагаем курьерскую доставку до двери, доставку в пункты самовывоза и экспресс-доставку в день заказа (в зависимости от вашего региона).",
    },
    {
        id: 2,
        question: "Можно ли вернуть или обменять косметику, если она мне не подошла?",
        answer: "Да, вы можете вернуть или обменять косметику в течение 14 дней с момента покупки, при условии сохранения товарного вида и упаковки (за исключением открытой косметики и парфюмерии).",
    },
    // {
    //     id: 3,
    //     question: "Есть ли у вас программа лояльности для постоянных клиентов?",
    //     answer: "Да, у нас действует программа лояльности, которая позволяет накапливать бонусные баллы и получать скидки.",
    // },
    {
        id: 4,
        question: "Какие часы работы вашего магазина?",
        answer: "Наш магазин работает с 10:00 до 22:00 ежедневно.",
    },
    {
        id: 5,
        question: "Есть ли у вас блог с рекомендациями по уходу?",
        answer: "Да, вы можете найти полезные статьи в нашем блоге на сайте.",
    },
    {
        id: 6,
        question: "Как я могу оформить заказ?",
        answer: "Вы можете оформить заказ через наш сайт, добавив товары в корзину и заполнив данные для доставки. Также принимаем заказы в WhatsApp и Direct в Instagram.",
    },
    {
        id: 7,
        question: "Какую косметику вы продаете?",
        answer: "Мы предлагаем только оригинальную косметику от официальных дистрибьюторов и проверенных брендов. Вся продукция сертифицирована.",
    },
    {
        id: 8,
        question: "Какие способы оплаты доступны?",
        answer: "Вы можете оплатить заказ: \n✅ Онлайн-оплатой (выставим счет на Kaspi) \n✅ При самовывозе (наличными или картой)",
    },
    {
        id: 9,
        question: "Доставляете ли вы заказы по Казахстану?",
        answer: "Да! Мы доставляем заказы по всему Казахстану через Казпочту, СДЭК и курьерские службы. В Астане действует экспресс-доставка день в день.",
    },
    {
        id: 10,
        question: "Как получить скидку?",
        answer: "🎁 Получите скидку -5% за отметку в Instagram Stories \n🎁 Скидочная карта -5% за заказ от 25 000₸ \n🎁 Скидочная карта -10% за заказ от 50 000₸",
    },
    {
        id: 11,
        question: "Как узнать, какая косметика мне подходит?",
        answer: "Вы можете пройти бесплатную диагностику кожи в нашем магазине с помощью аппарата Soft FX, который подберет идеальный уход для вашей кожи.",
    },
    {
        id: 12,
        question: "Как следить за новинками и акциями?",
        answer: "Подписывайтесь на наш Instagram @vanil_kz_, там мы публикуем все скидки и спецпредложения!",
    },
    {
        id: 13,
        question: "Как связаться с поддержкой?",
        answer: "📲 WhatsApp: +7 707 106 59 85 \n📩 Instagram Direct: @vanil_kz_ ",
    }
];

function Faq() {
    return (
        <div className="container mx-auto md:px-4 py-8 sm:my-8">
            <h2 className="text-2xl font-bold mb-6 text-center">Часто задаваемые вопросы</h2>
            <div className="max-w-2xl mx-auto">
                {faqs.map((faq) => (
                    <FaqItem key={faq.id} faq={faq} />
                ))}
            </div>
        </div>
    );
};

export default Faq;